'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _EditableTitle = require('../../components/editableTitle/EditableTitle');

var _EditableTitle2 = _interopRequireDefault(_EditableTitle);

require('./BoardTitle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var BoardTitle = function BoardTitle(_ref) {
    var currentBoardId = _ref.currentBoardId,
        isEditable = _ref.isEditable,
        currentBoard = _ref.currentBoard;
    return _react2.default.createElement(
        'div',
        { className: 'BoardTitle' },
        _react2.default.createElement(_EditableTitle2.default, {
            element: currentBoard,
            elementId: currentBoardId,
            isEditable: isEditable,
            editorKey: 'CURRENT_BOARD_TITLE' })
    );
};

// Styles
// Lib


BoardTitle.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    isEditable: _propTypes2.default.bool,
    currentBoard: _propTypes2.default.object
};

exports.default = (0, _recompose.pure)(BoardTitle);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/BoardTitle.js
// module id = 770
// module chunks = 0